(() => {
  if (window.ohwPurchaseLayoutStarted) return;
  window.ohwPurchaseLayoutStarted = true;
  const visible = el => !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  const sync = root => {
    const shipping = root.querySelector('[data-ohw-shipping-summary]');
    if (!shipping) return;
    const selectors = '[data-toe-submit],[data-protector-submit],[data-loop-submit],[data-dial-add],[data-tape-buy],[data-ohw-compression-clean] button[type="submit"],.ohw-fallback-form button[type="submit"],.product-form__submit,lb-vd-qty-selector .lb-qty-selector-atc-button';
    const button = Array.from(root.querySelectorAll(selectors)).find(visible);
    if (!button) return;
    const dedicated = root.querySelector('[data-ohw-compression-clean] [data-ohw-compression-payment]');
    const payment = root.querySelector('[data-ohw-purchase-payment]') || dedicated || root.querySelector('[data-ohw-product-payment-slot]') || root.querySelector('.ohw-card-payments');
    if (!payment) return;
    payment.setAttribute('data-ohw-purchase-payment','');
    payment.classList.add('ohw-product-payment-slot--placed');
    if (button.nextElementSibling !== payment) button.after(payment);
    const form = button.closest('form');
    const host = form || payment;
    if (host.nextElementSibling !== shipping) host.after(shipping);
    const returns = Array.from(root.querySelectorAll('details')).find(detail => /return/i.test(detail.querySelector('summary')?.textContent || ''));
    if (returns) {
      returns.setAttribute('data-ohw-returns','');
      const approvedMarkup = '<summary>Returns &amp; eligibility</summary><p>Review our <a href="/policies/refund-policy">return policy</a> before opening or using the product.</p>';
      if (returns.dataset.ohwReturnsStandard !== 'true') {
        returns.innerHTML = approvedMarkup;
        returns.dataset.ohwReturnsStandard = 'true';
      }
    }
    root.querySelectorAll('.ohw-card-payments').forEach(row => {
      const keep = row === payment || payment.contains(row);
      if (!keep && row.style.display !== 'none') row.style.display = 'none';
    });
  };
  const init = scope => {
    const roots = scope.matches?.('.product__info-container,.ohw-tape-info') ? [scope] : scope.querySelectorAll('.product__info-container,.ohw-tape-info');
    roots.forEach(root => {
      if (root.dataset.ohwPurchaseLayout) return;
      root.dataset.ohwPurchaseLayout = 'true';
      let frame;
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => sync(root)); };
      new MutationObserver(schedule).observe(root, {childList:true,subtree:true});
      root.addEventListener('change',schedule);
      sync(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
